import { OrtItemResponse } from '@/types/service-response'

export class PostCodeData {
  public constructor (
    readonly id: number,
    readonly land: number,
    readonly plz: string,
    readonly ort: string,
    readonly region: string
  ) {}

  static createFromResponse (responseData: OrtItemResponse[]): Array<PostCodeData> {
    let result: Array<PostCodeData> = []
    if (responseData) {
      result = responseData.map((item: OrtItemResponse, idx: number ) => {
        return new PostCodeData(
          idx,
          item.Land,
          item.PLZ,
          item.Ort,
          item.Region
        )
      })
    }
    return result
  }
}
